/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Url_LabelInputs */

const cs_ebr_url_label = /** @type {(inputs: Ebr_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresa exportu eBrány`)
};

const en_ebr_url_label = /** @type {(inputs: Ebr_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eBrána export address`)
};

/**
* | output |
* | --- |
* | "eBrána export address" |
*
* @param {Ebr_Url_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_url_label = /** @type {((inputs?: Ebr_Url_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Url_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_url_label(inputs)
	return cs_ebr_url_label(inputs)
});